<template>
    <Modal :show="show" :max-width="maxWidth" :closeable="closeable" @close="close">
        <div class="confirmation-content-body">
            <div class="confirmation-content-body-message">
                <div
                    class="confirmation-content-body-icon"
                    :class="{
                        'confirmation-content-body-icon--error': props.type === 'error',
                        'confirmation-content-body-icon--warning': props.type === 'warning',
                        'confirmation-content-body-icon--info': props.type === 'info',
                        'confirmation-content-body-icon--success': props.type === 'success',
                    }"
                >
                    <svg
                        class="confirmation-content-body-icon__icon"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                    </svg>
                </div>

                <div class="confirmation-content-body__message">
                    <h3 class="confirmation-content-body__message-title">
                        <slot name="title"></slot>
                    </h3>

                    <div class="confirmation-content-body__message-content">
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        </div>

        <div class="confirmation-content-footer">
            <slot name="footer"> </slot>
        </div>
    </Modal>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';

const emit = defineEmits<{
    (event: 'close'): void;
}>();

interface Props {
    show?: boolean;
    maxWidth?: string;
    closeable?: boolean;
    type?: 'error' | 'warning' | 'info' | 'success';
}

const props = withDefaults(defineProps<Props>(), {
    show: false,
    maxWidth: '2xl',
    closeable: true,
    type: 'error',
});

toRefs(props);

const close = () => {
    if (props.closeable) {
        emit('close');
    }
};
</script>
